import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle, statusColor } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const money = (n) => "$" + (Math.round(n || 0)).toLocaleString();
const FLOW = ["COMMISSION_REVIEW", "COMMISSION_APPROVED", "COMMISSION_PAID"];

export default function CommissionsAdmin() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/commissions").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const advance = async (c, status) => {
    await api.patch(`/admin/commissions/${c.id}`, { status, note: `Set to ${status}` }); toast.success(status.replace(/_/g, " ")); load();
  };

  return (
    <div>
      <PageTitle title="Commissions" subtitle="Approve payouts — placement complete does not mean commission paid" />
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-commissions-table">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr>{["Provider", "Service", "Amount", "Status", "Action"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((c) => {
                const idx = FLOW.indexOf(c.status);
                const next = idx >= 0 && idx < FLOW.length - 1 ? FLOW[idx + 1] : null;
                return (
                  <tr key={c.id} className="hover:bg-slate-50" data-testid={`admin-commission-${c.id}`}>
                    <td className="px-4 py-3 font-medium text-navy">{c.provider || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{c.service_category || "—"}</td>
                    <td className="px-4 py-3 font-semibold text-emeraldbrand">{money(c.amount)}</td>
                    <td className="px-4 py-3"><Badge className={`${statusColor(c.status)} hover:${statusColor(c.status)}`}>{(c.status || "").replace(/_/g, " ")}</Badge></td>
                    <td className="px-4 py-3">{next && <Button size="sm" className="bg-navy hover:bg-navy/90" onClick={() => advance(c, next)} data-testid={`commission-advance-${c.id}`}>Move to {next.replace("COMMISSION_", "").replace(/_/g, " ")}</Button>}</td>
                  </tr>
                );
              })}
              {items.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No commissions in review. These are created when placements are verified.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
